import archives from './archives'
import archives_and_money_give_outs from './archives_and_money_give_outs'
import money from './money'


export default [
    ...archives,
    ...archives_and_money_give_outs,
    ...money
]